//import axios from "axios";
import { Locale } from "../frame/Locale.js";
import { ConfigService } from "./ConfigService.js";
export { Config };
const local = new Locale("Config");
/**
 * Загружает конфигурацию сервиса из config.json.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class Config {
  /**
   * Путь к файлу конфигурации.
   * Защищённый доступ через `getPath` и `setPath`.
   * @type {string}
   * @ignore
   */
  static _path = "config.json";
  /**
   * Обещание загрузить файл конфигурации.
   * @type {Promise?}
   * @ignore
   */
  static _promise = null;
  /**
   * Загруженная конфигурация сохраняется в `_cache`.
   * @type {Object?}
   * @ignore
   */
  static _cache = null;
  /**
   * @returns {string} Путь к файлу конфигурации.
   */
  static getPath() {
    return Config._path;
  }
  /**
   * @param {string} param - Название параметра конфигурации.
   * @returns {any} Значение параметра конфигурации.
   */
  static get(param) {
    if (!Config._cache)
      throw local.invalid("[before_load].get", param);
    if (undefined === Config._cache[param])
      throw local.invalid("config." + param, undefined);
    else
      return Config._cache[param];
  }
  /**
   * Устанавливает путь к файлу конфигурации.
   *
   * Путь можно изменить до первого вызова `load`.
   *
   * @param {string} path - Путь к файлу конфигурации.
   * @returns {void}
   */
  static setPath(path) {
    if (Config._promise)
      throw local.invalid("[after_load].setPath", path);
    else
      Config._path = path;
  }
  /**
   * Устанавливает загруженные ранее данные конфигурации.
   * @param {Object} data - Содержимое файла конфигурации.
   */
  static setConfigData(data) {
    Config._cache = data;
  }
  /**
   * Загружает файл конфигурации.
   * @return {Promise<void>}
   */
  static async load() {
    if (Config._cache) return;
    try {
      if (!Config._promise)
        Config._promise = fetch(Config._path).then(async response => {
          if (200 === response.status) return await response.json();
          else throw local.error("load_error",
            {
              message: "HTTP " + response.status,
              response: await response.text()
            });
        });
      Config._cache = await Config._promise;
    }
    catch (error) {
      throw local.error("load_error",
        { message: error.message, response: error.response });
    }
  }
  /**
   * Создаёт сервис с URL из конфигурации.
   *
   * @param {string} service_name - Параметр конфигурации с URL сервиса.
   * @example
import { Config } from "../personal-studio-components/service/index.js";
const service = Config.createService("open_test_service");
   * @example <caption>config.json</caption>
{
"open_test_service": "https://uits-demo2.roweb.online/api/player/open-test/v1"
}
   */
  static createService(service_name) {
    return new ConfigService(service_name);
  }
}
